import { validateInvoiceNotesReceipt } from "./privateInvoiceNotesProtocol";

// Used only by the staff-label route, after a fresh authenticated private read.
// Never merge this result into activity state, invoice JSON, search, or history.
export function buildStaffInvoiceLabel(publicData, receipt, includeInternal = true) {
  const result = JSON.parse(JSON.stringify(publicData));
  delete result.staffPrivateComments;
  for (const key of ["tasks", "customerMaterials"]) {
    result[key] = (result[key] || []).map(row => { const next = { ...row }; delete next.staffInternalNote; return next; });
  }
  if (!includeInternal) return result;
  validateInvoiceNotesReceipt(receipt);
  const ids = [...result.tasks, ...result.customerMaterials].map(row => row.lineId).filter(Boolean);
  for (const key of ["tasks", "customerMaterials"]) {
    result[key] = result[key].map(row => {
      const note = row.lineId && receipt.entries[row.lineId];
      // An ambiguous legacy line ID must not attach a note to multiple rows.
      return note?.kind === "lineNote" && ids.filter(id => id === row.lineId).length === 1
        ? { ...row, staffInternalNote: note.text } : row;
    });
  }
  result.staffPrivateComments = Object.values(receipt.entries).filter(entry => entry.kind === "comment")
    .map(entry => ({ text: entry.text, note: entry.note }));
  return result;
}

export async function renderPrivateInvoiceLabel({ publicData, identity, client, render, approvedDestination = false, isCurrent = () => true }) {
  // Deployment/renderer-data approval is separate from label visibility.
  // This gate is off in every normal build until that approval is supplied.
  if (!approvedDestination) throw new Error("The internal label renderer has not been enabled yet.");
  if (!identity || !isCurrent()) throw new Error("The label session changed. Reopen the job to print.");
  const receipt = await client.readInvoiceNotes(identity);
  if (!isCurrent()) throw new Error("The label session changed. Reopen the job to print.");
  const data = buildStaffInvoiceLabel(publicData, receipt);
  const result = await render(data);
  if (!isCurrent()) throw new Error("The label session changed. Reopen the job to print.");
  return result;
}

export async function fetchPrivateLabelPdf({ url, auth, data, fetchImpl = fetch }) {
  if (url.replace(/\/$/, "") !== "https://miralouaero.jsreportonline.net") throw new Error("Internal label destination is not configured.");
  const response = await fetchImpl(url.replace(/\/$/, "") + "/api/report", {
    method: "POST", headers: { Authorization: auth, "Content-Type": "application/json" },
    credentials: "omit", redirect: "error", referrerPolicy: "no-referrer", cache: "no-store",
    body: JSON.stringify({ template: { name: "cc-label" }, data, options: { reports: { save: false } } })
  });
  if (!response.ok) throw new Error("The internal label could not be rendered.");
  return response.blob();
}
